import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ProjetoCulturalListar from '../../components/projetocultural/listar';


function ProjetoCulturalScreen () {
    return (
        <Fragment>
            <Head titulo="Listagem de Projetos Culturais fruto de renúncia de Receitas no Município de Macuco"/>
            <Header />
            <Container>
                <ProjetoCulturalListar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ProjetoCulturalScreen;